"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68],{

/***/ 15948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CruiseSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88494);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72821);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var components_helper_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34892);
/* harmony import */ var components_helper_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1075);
/* harmony import */ var lib_filters_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62279);
/* harmony import */ var lib_connect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43424);
/* harmony import */ var _public_assets_icons_anker_user_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68395);
/* harmony import */ var _public_assets_icons_anker_bed_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6231);
/* harmony import */ var _public_assets_icons_anker_length_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54319);
/* harmony import */ var _public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55500);
/* harmony import */ var _public_assets_icons_anker_port_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20614);

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved













function CruiseSlider(param) {
    var searchQueryParams = param.searchQueryParams;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), boats = ref[0], setBoats = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var params = searchQueryParams;
        if ((searchQueryParams === null || searchQueryParams === void 0 ? void 0 : searchQueryParams.limit) === undefined) {
            params.limit = 10;
        }
        (0,lib_connect__WEBPACK_IMPORTED_MODULE_9__/* .fetchAPI */ .Io)('/search', params).then(function(data) {
            setBoats(data.data);
        });
    }, [
        searchQueryParams
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: boats.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                '@0.1': {
                    slidesPerView: 1
                },
                '@0.75': {
                    slidesPerView: 2
                },
                '@1.00': {
                    slidesPerView: 3
                }
            },
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
            ],
            navigation: true,
            className: "w-full",
            children: boats.map(function(offer, k) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_helper_link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: {
                            pathname: "/yacht/".concat(offer.boat.slug),
                            query: {
                                bq: offer.booking_query,
                                date_from: offer.date_from,
                                date_to: offer.date_to,
                                duration: offer.duration
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "text-primary cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                    className: "p-1 pb-0 font-bold bg-action text-center",
                                    children: offer.boat.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                    src: (0,components_helper_image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(offer.boat.photo_url, {
                                        w: 1000
                                    }),
                                    layout: "responsive",
                                    width: "400",
                                    height: "250",
                                    objectFit: "cover",
                                    alt: offer.boat.title,
                                    title: offer.boat.title
                                }),
                                offer.license === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "-mt-7 w-3/5 relative bg-primary bg-opacity-75 text-white text-sm p-1 text-center",
                                    children: "auch ohne F\xfchrerschein"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative p-2 bg-gray-200 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center basis-full font-semibold",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: "mr-2",
                                                    width: 14
                                                }),
                                                (0,lib_filters_date__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(offer.date_from),
                                                ' ',
                                                "-",
                                                ' ',
                                                (0,lib_filters_date__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(offer.date_to),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "text-xs ml-2 leading-4 font-semibold bg-gray-100 rounded-xl text-primary-500 text-center py-0.5 px-2.5",
                                                    children: [
                                                        offer.duration,
                                                        ' ',
                                                        "N\xe4chte"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_port_svg__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: "mr-2 ml-0.5 fill-primary",
                                                    width: 12
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "line-clamp-1",
                                                    children: offer.basement_start.location.half
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: " basis-1/3 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_user_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                    height: 14,
                                                                    className: "mr-2 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Kojen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "ml-6",
                                                            children: [
                                                                offer.boat.berth.fixed,
                                                                "(+",
                                                                offer.boat.berth.variable,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "basis-1/3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_bed_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    height: 14,
                                                                    className: "mx-2 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Kabinen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "ml-7",
                                                            children: offer.boat.cabins
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "basis-1/3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_length_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                    height: 14,
                                                                    className: "mx-2 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "L\xe4nge"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "ml-7",
                                                            children: [
                                                                offer.boat.length,
                                                                "\xa0m"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-right font-bold pr-2 w-1/2 bg-primary text-white relative left-1/2",
                                        children: [
                                            "schon ab",
                                            ' ',
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                children: [
                                                    offer.price,
                                                    "\xa0€"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }, k);
            })
        })
    }));
};


/***/ }),

/***/ 58130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Faq; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40169);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45363);
/* harmony import */ var _headline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17587);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Faq(param) {
    var item = param.item;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", _objectSpread({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_1__/* .jsonLdScriptProps */ .h6)({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: item.content.items.map(function(i) {
                    return {
                        '@type': 'Question',
                        name: i.header,
                        acceptedAnswer: {
                            '@type': 'Answer',
                            text: i.bodytext
                        }
                    };
                })
            }))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        after: "Fragen",
                        children: "H\xe4ufig gestellte"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                            className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12",
                            children: item.content.items.map(function(faq, k) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dt", {
                                            className: "text-lg leading-6 font-medium text-gray-900 flex flex-nowrap",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    className: "w-5 -ml-1 mr-1 text-action flex-shrink-0"
                                                }),
                                                faq.header
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                            className: "mt-2 text-base text-gray-500 pl-5 flex-grow",
                                            dangerouslySetInnerHTML: {
                                                __html: faq.bodytext
                                            }
                                        })
                                    ]
                                }, faq.header + k);
                            })
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 5205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13342);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Select(param) {
    var children = param.children, label = param.label, id = param.id, register = param.register, error = param.error, name = param.name, selected = param.selected, _mainClass = param.mainClass, mainClass = _mainClass === void 0 ? '' : _mainClass, _options = param.options, options = _options === void 0 ? [] : _options, _primary = param.primary, primary = _primary === void 0 ? false : _primary;
    var okLabelColor = primary ? 'text-gray-600' : 'text-primary';
    var labelColor = error ? 'text-red-600' : okLabelColor;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(mainClass, " relative border border-1 ").concat(primary ? 'bg-white border-gray-100' : 'bg-gray-100 border-gray-400', " group w-full transition-all overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", _objectSpread({}, register, {
                className: "input-text z-[3] rounded-none relative block w-full px-2 ".concat(label ? 'py-1 pt-5' : 'py-2', " bg-transparent border-b-2 border-0 border-transparent group-hover:border-secondary focus:outline-none focus:border-primary ring-0 ").concat(error ? 'border-red-600s' : ''),
                id: id,
                name: name,
                defaultValue: "",
                children: options.length ? options.map(function(option, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: option.value,
                        selected: option.value === selected,
                        children: option.label
                    }, index);
                }) : children
            })),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "absolute top-1 z-10 block w-9/10 px-2 text-xs font-bold ".concat(labelColor),
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "absolute right-2 top-1/2 -translate-y-1/2 h-5 fill-gray-400"
            })
        ]
    }));
};


/***/ }),

/***/ 90647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BoatTypeSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./src/components/elements/dropdown.js
var dropdown = __webpack_require__(52800);
// EXTERNAL MODULE: ./src/components/globals/input-wrapper.js
var input_wrapper = __webpack_require__(75565);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/assets/icons/anker/type.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgType = function SvgType(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.5 209",
    style: {
      enableBackground: "new 0 0 337.5 209"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.6 134.5c11.8.8 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 13.2-1.6 18.2-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 2.6.3 4.7 2.4 4.7 5v-25.8c.3-2.9-1.8-5.5-4.7-5.5-11.8-1.1-18.2 2.4-23.7 5.5-5 2.6-9.5 5-17.9 4.2-8.7-.8-12.6-3.7-17.1-7.1-2.6-2.1-5.5-4.2-9.5-6.1 7.6-9.2 21.6-26.8 32.4-45.5 5.3-9.5 10-19.2 12.1-28.2 1.3 0 2.9 0 4.2.3 2.9 0 5.3-2.1 5.5-5 0-2.9-2.1-5.3-5-5.5-2.9-.3-9.2-.3-9.2-.3-25.5-.5-52.1.8-78.4 3.7 0-.3-.3-.3-.3-.5L197.3 4.3c-1.1-1.8-3.2-2.6-5-2.4L126 9.8h-.3c-.3 0-.5.3-.8.3 0 0-.3 0-.5.3 0 0-.3 0-.3.3L79.4 34.8c-1.6 1.1-2.6 2.6-2.6 4.7v38.7C43.1 86.9 21.6 93.7 21 94c-1.8.5-3.2 2.1-3.4 3.7l-2.9 11.8c-2.4-.8-5-1.1-8.2-1.3-3.2-.3-5.5 1.8-5.8 4.7v26.6-.5c.3-2.6 2.7-4.7 5.9-4.5zM295.9 63c-2.1 5-4.5 10.5-7.6 15.8-34.2 10.5-89.7 20.3-132.8 27.1 11-10.8 43.9-31.4 140.4-42.9zm-106-50.3 24.5 38.9c-19.2 2.4-37.9 5.3-56 8.7l-23.4-41 54.9-6.6zm90.5 79.2c-10.5 16.3-22.6 30.8-27.1 36-.8 0-1.3-.3-2.1-.3-11.8-.8-18.1 2.4-23.7 5.5-5 2.6-9.5 5-18.1 4.2-8.7-.8-12.6-3.7-17.1-7.1-5-3.9-10.8-8.2-22.6-9.2-11.8-1.1-18.2 2.4-23.7 5.5-5 2.6-9.5 5-17.9 4.2-8.7-.8-12.6-3.7-17.1-7.1-.5-.3-.8-.5-1.3-1.1 35-4.3 118.4-16.1 170.7-30.6z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M331.7 171.1c-8.7-.8-12.9 1.6-18.2 4.2-5 2.6-10.5 5.5-20 5.5-1.3 0-2.4 0-3.9-.3-11.8-.8-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1-8.7-.8-12.9 1.6-18.2 4.2-5.5 2.9-12.1 6.3-23.7 5.5-11.8-1.1-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1s-12.9 1.6-18.2 4.2c-5.5 2.9-12.1 6.3-23.7 5.5s-17.6-5.3-22.6-9.2c-4.5-3.4-8.4-6.3-17.1-7.1-8.7-.8-12.9 1.6-18.2 4.2-5.5 2.9-12.1 6.3-23.7 5.5-11.8-1.1-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1-2.6-.3-4.7-2.6-4.7-5.3v25.8c-.3 2.9 1.8 5.3 4.5 5.5 0 .3.3.3.3.3H6c8.2.8 11.8 3.7 16.3 7.1 5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2 8.7.8 12.6 3.7 17.1 7.1 5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2s12.6 3.7 17.1 7.1c5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2 8.7.8 12.6 3.7 17.1 7.1 5 3.9 10.8 8.2 22.6 9.2 1.3 0 2.6.3 3.9.3 9.5 0 15-2.9 20-5.5 4.7-2.6 9.2-4.7 17.1-4.2.3 0 .5.3.8.3 0 0 .3 0 .3-.3 2.9 0 5.3-2.1 5.3-4.7v-26.3c.1 2.9-2.5 5-5.4 4.7z"
  })));
};

/* harmony default export */ var type = (SvgType);
;// CONCATENATED MODULE: ./src/components/search/form/boat-type-select.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BoatTypeSelect(_param) {
    var value1 = _param.value, setValue = _param.setValue, rest = _objectWithoutProperties(_param, [
        "value",
        "setValue"
    ]);
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            boat_type_id: value1
        }
    }), control = ref.control, watch = ref.watch;
    watch(function(v) {
        setValue('boat_type_id', v.boat_type_id);
        // @todo workaround, close popover correctly
        document.getElementById('boat-type-apply-button').click();
    });
    var options = [
        {
            label: 'Alle Bootsarten',
            value: ''
        },
        {
            label: 'Segelyachten',
            value: 'in:1,8,15,20,16,31'
        },
        {
            label: 'Motoryachten',
            value: 'in:6,14,24,26,5,9,12,11,18,25,39'
        },
        {
            label: 'Katamarane',
            value: 'in:10,13,17'
        }
    ];
    var getLabelForValue = function(value) {
        var selected = options.find(function(item) {
            return item.value === value;
        });
        if (selected) {
            return selected.label;
        }
        return options[0].label;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(input_wrapper/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(type, {
            className: "absolute right-0 z-10 w-5 h-6 -mt-px pointer-events-none fill-action top-3 left-2"
        }),
        children: [
            ' ',
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                control: control,
                name: "boat_type_id",
                render: function(param) {
                    var _field = param.field, onChange = _field.onChange, value = _field.value;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(dropdown/* default */.Z, _objectSpread({
                        value: "".concat(getLabelForValue(value))
                    }, rest, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center justify-between w-full px-5 pt-2 pb-1 border-b border-gray-100 lg:border-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "text-sm font-semibold",
                                    children: "Bootsart"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full pt-5 lg:pt-0 space-y-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "grid divide-y divide-action",
                                    children: options.map(function(i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: "transition-all duration-200 px-5 py-2 cursor-pointer ".concat(value === i.value ? 'bg-primary text-action hover:bg-primary-600' : 'bg-gray-50 hover:bg-gray-200'),
                                            onClick: function() {
                                                return onChange(i.value);
                                            },
                                            children: i.label
                                        }, i.label);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center justify-between w-full py-3 flex-nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                    id: "boat-type-apply-button",
                                    className: "w-full mx-3 border border-transparent rounded text-center appearance-none select-none bg-primary-500 text-white hover:text-white hover:bg-action-500 active:bg-action-500 text-sm px-4 h-10",
                                    children: "Ok"
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};


/***/ }),

/***/ 74675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/core-js/features/object/from-entries.js
var from_entries = __webpack_require__(76554);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/connect.js
var connect = __webpack_require__(43424);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./src/components/helper/image.js + 1 modules
var helper_image = __webpack_require__(1075);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 6 modules
var dialog = __webpack_require__(63325);
// EXTERNAL MODULE: ./src/components/globals/modal.js
var modal = __webpack_require__(50795);
;// CONCATENATED MODULE: ./src/components/search/basement.js








function LoadingOrNotFound(param) {
    var loading = param.loading;
    return loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                as: "h3",
                className: "text-lg leading-6 font-medium text-gray-900 px-6 mb-4",
                children: "L\xe4dt..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-primary p-6",
                children: "Wir bitten im einen kurzen Moment Geduld."
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Die Information konnte leider nicht gefunden werden."
    });
}
function Basement(param) {
    var open = param.open, setOpen = param.setOpen, basementId = param.basementId;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), basement = ref1[0], setBasement = ref1[1];
    var BasementMap = (0,react.useMemo)(function() {
        return (0,dynamic["default"])(function() {
            return Promise.all(/* import() */[__webpack_require__.e(269), __webpack_require__.e(773)]).then(__webpack_require__.bind(__webpack_require__, 14773));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(14773)
                    ];
                }
            },
            ssr: false,
            loading: function() {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                    children: "Loading"
                });
            }
        });
    }, []);
    var fetchData = function() {
        (0,connect/* fetchAPI */.Io)("/basement/".concat(basementId, "?geojson=true&region=true")).then(function(result) {
            setBasement(result.data);
        }).finally(function() {
            return setLoading(false);
        });
    };
    (0,react.useEffect)(function() {
        fetchData();
    }, [
        basementId
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        open: open,
        setOpen: setOpen,
        loading: loading,
        children: basement ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pt-4 pb-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                    as: "h3",
                    className: "text-lg leading-6 font-medium text-gray-900 px-6 mb-4",
                    children: basement.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BasementMap, {
                            basement: basement
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4",
                            children: [
                                basement.photo_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[300px] h-[200px] float-right ml-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: (0,helper_image/* default */.Z)(basement.photo_url),
                                        layout: "fixed",
                                        objectFit: "cover",
                                        height: "200",
                                        width: "300",
                                        alt: basement.name,
                                        title: basement.name,
                                        style: {
                                            float: 'right'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: basement.description
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOrNotFound, {
            loading: loading
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/lib/filters/date.js
var date = __webpack_require__(62279);
// EXTERNAL MODULE: ./node_modules/react-schemaorg/dist/src/index.js
var src = __webpack_require__(45363);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/components/search/offer-catalog-schema.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OfferCatalogSchema(param) {
    var items = param.items;
    var offers = function() {
        return items.map(function(item) {
            return {
                '@type': [
                    'Product',
                    'Yacht'
                ],
                name: item.boat.title,
                availability: 'https://schema.org/InStock',
                description: item.boat.description,
                sku: item.boat.id,
                mpn: item.boat.id,
                url: "".concat("https://www.chartercheck.com", "/yacht/").concat(item.boat.slug),
                offers: [
                    {
                        price: item.boat.min_price,
                        priceCurrency: 'EUR',
                        priceValidUntil: moment_default()().format('YYYY-MM-DD')
                    }
                ]
            };
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", _objectSpread({}, (0,src/* jsonLdScriptProps */.h6)([
            {
                '@context': 'https://schema.org/',
                '@type': [
                    'Product',
                    'Yacht'
                ],
                serviceType: 'Boat charter',
                brand: {
                    '@type': 'Brand',
                    name: 'CharterCheck'
                },
                hasOfferCatalog: {
                    '@type': 'OfferCatalog',
                    name: 'Boat offers',
                    itemListElement: [
                        offers(), 
                    ]
                }
            }, 
        ])))
    }));
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/boat/CharterLicenseNotice.js
var CharterLicenseNotice = __webpack_require__(48398);
// EXTERNAL MODULE: ./src/lib/adac.js
var adac = __webpack_require__(90313);
// EXTERNAL MODULE: ./public/assets/icons/anker/port.svg
var port = __webpack_require__(20614);
// EXTERNAL MODULE: ./src/components/helper/link.js
var helper_link = __webpack_require__(34892);
// EXTERNAL MODULE: ./src/lib/filters/price.js
var price = __webpack_require__(71521);
// EXTERNAL MODULE: ./public/assets/icons/anker/user.svg
var user = __webpack_require__(68395);
// EXTERNAL MODULE: ./public/assets/icons/anker/bed.svg
var bed = __webpack_require__(6231);
// EXTERNAL MODULE: ./public/assets/icons/anker/length.svg
var anker_length = __webpack_require__(54319);
;// CONCATENATED MODULE: ./public/assets/icons/anker/construction.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgConstruction = function SvgConstruction(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m30.391 12.68-3.064-.614a12.098 12.098 0 0 0-.537-1.289l1.736-2.604a1.999 1.999 0 0 0-.25-2.523l-1.924-1.924a1.996 1.996 0 0 0-2.523-.25l-2.604 1.735a12.09 12.09 0 0 0-1.291-.536L19.32 1.61A1.998 1.998 0 0 0 17.359.002h-2.72a2 2 0 0 0-1.961 1.608l-.614 3.065c-.443.154-.873.335-1.289.536L8.172 3.476a1.996 1.996 0 0 0-2.524.25L3.725 5.65a2 2 0 0 0-.25 2.523l1.735 2.604c-.202.417-.382.847-.536 1.29l-3.066.613A2 2 0 0 0 0 14.641v2.72a2 2 0 0 0 1.608 1.961l3.065.615c.154.443.335.873.536 1.289L3.475 23.83a1.999 1.999 0 0 0 .25 2.523l1.924 1.924a1.996 1.996 0 0 0 2.523.25l2.604-1.736c.417.203.847.383 1.29.537l.613 3.064a2 2 0 0 0 1.961 1.609h2.72a2 2 0 0 0 1.961-1.609l.615-3.064c.443-.154.873-.336 1.289-.537l2.604 1.736a1.998 1.998 0 0 0 2.523-.25l1.924-1.924a2 2 0 0 0 .25-2.523l-1.736-2.604c.203-.418.383-.848.537-1.291l3.064-.613A2 2 0 0 0 32 17.361v-2.72c0-.953-.674-1.774-1.609-1.961zm-3.457 5.295a1.997 1.997 0 0 0-1.496 1.305c-.129.369-.279.727-.447 1.074a1.996 1.996 0 0 0 .135 1.982l1.736 2.604-1.924 1.924-2.604-1.736a1.997 1.997 0 0 0-1.98-.137c-.348.168-.705.32-1.076.449a1.998 1.998 0 0 0-1.303 1.496l-.615 3.066h-2.72l-.613-3.066a1.997 1.997 0 0 0-1.304-1.496 10.17 10.17 0 0 1-1.075-.447 1.994 1.994 0 0 0-1.981.135l-2.604 1.736-1.924-1.924 1.735-2.604c.393-.59.444-1.344.137-1.98a10.106 10.106 0 0 1-.448-1.076 2 2 0 0 0-1.496-1.303l-3.065-.615L2 14.641l3.066-.613a1.999 1.999 0 0 0 1.496-1.304c.129-.369.278-.728.447-1.075a1.995 1.995 0 0 0-.136-1.981L5.139 7.064 7.062 5.14l2.604 1.735a1.997 1.997 0 0 0 1.98.137 10.09 10.09 0 0 1 1.075-.448 1.999 1.999 0 0 0 1.304-1.496l.614-3.065 2.72-.001.613 3.066a1.998 1.998 0 0 0 1.305 1.496c.369.129.727.278 1.074.447a1.998 1.998 0 0 0 1.982-.136l2.604-1.735 1.924 1.924-1.736 2.604a2.006 2.006 0 0 0-.137 1.98c.168.347.32.705.449 1.075a1.997 1.997 0 0 0 1.496 1.304l3.064.614.003 2.72-3.066.614zM16 9.001A7 7 0 1 0 16.001 23 7 7 0 0 0 16 9zm0 13.126c-3.382 0-6.125-2.744-6.125-6.125S12.618 9.877 16 9.877a6.127 6.127 0 0 1 6.125 6.125A6.127 6.127 0 0 1 16 22.127zm0-10.126c-2.21 0-4 1.79-4 4s1.79 4 4 4a4 4 0 0 0 0-8zm0 7.001a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6z"
  })));
};

/* harmony default export */ var construction = (SvgConstruction);
;// CONCATENATED MODULE: ./public/assets/icons/anker/lightning.svg
var lightning_path;

function lightning_extends() { lightning_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lightning_extends.apply(this, arguments); }



var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/react.createElement("svg", lightning_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), lightning_path || (lightning_path = /*#__PURE__*/react.createElement("path", {
    d: "m12.886 10.667 3.264-8.591H7.889L2.992 14.933H8.49l-3.164 8.748 13.015-13.015zm-7.46 6.4H0L6.4 0h12.8l-3.207 8.591h7.474L0 32l5.426-14.933z"
  })));
};

/* harmony default export */ var lightning = (SvgLightning);
// EXTERNAL MODULE: ./public/assets/icons/anker/calendar.svg
var calendar = __webpack_require__(55500);
;// CONCATENATED MODULE: ./public/assets/icons/anker/mainsail.svg
var mainsail_path, _path2;

function mainsail_extends() { mainsail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mainsail_extends.apply(this, arguments); }



var SvgMainsail = function SvgMainsail(props) {
  return /*#__PURE__*/react.createElement("svg", mainsail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 38 32"
  }, props), mainsail_path || (mainsail_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.109 32h-.62l-.072-.211c-.658-2.047-.411-4.14-.126-5.943.999-6.387 3.955-12.477 9.294-19.175.767-.963 1.613-1.874 2.428-2.755.702-.759 1.429-1.543 2.095-2.35.168-.192.345-.366.534-.525l.007-.006c.089-.08.181-.16.276-.251l.346-.323.689 1.815a6.48 6.48 0 0 1 .673 1.944l.006.04c.063.285.129.575.211.843 2.454 8.388 6.181 15.412 11.396 21.487a28.788 28.788 0 0 0 2.692 2.856l.019.017c.264.232.786.691.382 1.299-.318.476-.843.323-1.111.238l-.11-.032c-3.373-.913-6.219-1.459-8.936-1.718l-.89-.089a34.284 34.284 0 0 0-4.214-.257h-.213c-.396.017-.881.04-1.307-.27-5.217.318-9.29 1.235-12.808 2.888l-.162.072c-.196.082-.32.137-.388.251zM15.022 1.56a3.648 3.648 0 0 0-.418.405l-.003.004a60.113 60.113 0 0 1-2.123 2.376c-.807.875-1.644 1.777-2.397 2.721C4.811 13.673 1.898 19.67.915 25.929c-.255 1.623-.481 3.493 0 5.3.122-.087.261-.163.408-.221l.013-.005.139-.061c3.622-1.701 7.8-2.637 13.16-2.951h.131l.097.086c.257.228.586.211.968.196h.226c1.513.001 3.003.095 4.465.277l-.176-.018.887.089c2.753.264 5.626.816 9.039 1.739l.126.036c.316.095.36.08.403.015.067-.101.084-.158-.259-.462a28.749 28.749 0 0 1-2.747-2.902l-.039-.049c-5.201-6.054-9.067-13.359-11.512-21.706a8.712 8.712 0 0 1-.211-.892c-.148-.654-.287-1.265-.618-1.821l-.027-.049z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M14.661 28.321c5.531-.099 10.945.694 16.354 2.119-.573-.607-1.147-1.216-1.724-1.821-6.128-6.415-10.119-14.04-12.743-22.442-.382-1.229-.843-2.445-.873-3.763L15.818 0l22.453 31.018c-.535.027-.93.061-1.324.065q-10.837.112-21.673.211c-.491 0-.782-.034-.7-.668.095-.757.063-1.535.086-2.304z"
  })));
};

/* harmony default export */ var mainsail = (SvgMainsail);
;// CONCATENATED MODULE: ./public/assets/icons/anker/genoa.svg
var genoa_path, genoa_path2;

function genoa_extends() { genoa_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return genoa_extends.apply(this, arguments); }



var SvgGenoa = function SvgGenoa(props) {
  return /*#__PURE__*/react.createElement("svg", genoa_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 38 32"
  }, props), genoa_path || (genoa_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.092 28.697c-4.427.253-8.755.957-12.814 2.864-.242.114-.522.182-.675.439H.396c-.605-1.887-.414-3.806-.114-5.695 1.12-7.14 4.639-13.131 9.068-18.683 1.396-1.75 3.017-3.29 4.44-5.011.245-.264.498-.508.764-.737l.012-.01.524 1.375c.507.843.586 1.822.855 2.738 2.299 7.844 5.914 14.991 11.253 21.213a29.208 29.208 0 0 0 2.673 2.837l.019.017c.253.224.572.493.321.87-.207.319-.569.155-.859.077-2.519-.744-5.516-1.342-8.591-1.677l-.237-.021c-1.679-.162-3.357-.373-5.049-.34-.47.017-.979.108-1.383-.255z"
  })), genoa_path2 || (genoa_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M14.609 31.934a.781.781 0 0 1-.909-1.014l-.002.006c.047-.417.073-.9.073-1.39l-.001-.163v-.982h.296c4.854-.089 9.807.509 15.117 1.824-.319-.338-.636-.673-.957-1.008-5.668-5.951-9.787-13.203-12.578-22.166-.06-.195-.122-.387-.184-.58-.329-1.019-.669-2.071-.688-3.204v-.023l.193-3.235.511.694 22.392 30.934-.572.029-.491.027c-.3.019-.559.033-.828.037l-7.215.07q-7.041.068-14.081.143zm-.207-2.932v.385l.001.159c0 .514-.028 1.021-.083 1.519l.005-.062c-.029.222 0 .275 0 .275a.971.971 0 0 0 .375.033h-.004q7.041-.077 14.081-.143l1.601-.017-.29-.075c-5.541-1.466-10.671-2.137-15.693-2.077zM15.4 3.253c.017 1.035.342 2.038.654 3.009.064.207.128.391.188.588 2.76 8.875 6.834 16.047 12.445 21.924.385.414.766.808 1.149 1.213l1.098 1.162 5.047-.05c.228 0 .458-.017.719-.031L15.487 1.762z"
  })));
};

/* harmony default export */ var genoa = (SvgGenoa);
;// CONCATENATED MODULE: ./public/assets/icons/anker/dog.svg
var dog_path;

function dog_extends() { dog_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_extends.apply(this, arguments); }



var SvgDog = function SvgDog(props) {
  return /*#__PURE__*/react.createElement("svg", dog_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), dog_path || (dog_path = /*#__PURE__*/react.createElement("path", {
    d: "M24.2 18.664a2.307 2.307 0 0 1-1.402-2.128 6.807 6.807 0 0 0-2.417-5.238.47.47 0 0 0-.607.716 5.87 5.87 0 0 1 2.085 4.515 3.244 3.244 0 0 0 1.967 2.996 5.845 5.845 0 0 1 3.525 5.476c-.026 1.514-.634 2.945-1.714 4.028s-2.508 1.698-4.022 1.728a5.79 5.79 0 0 1-3.682-1.205 3.182 3.182 0 0 0-3.867 0 5.793 5.793 0 0 1-3.682 1.205c-1.514-.031-2.942-.645-4.022-1.728s-1.688-2.514-1.714-4.028a5.845 5.845 0 0 1 3.525-5.476 3.251 3.251 0 0 0 1.967-3.001v-.039c0-1.585.623-3.069 1.753-4.18s2.627-1.708 4.213-1.678c.299.005.599.034.893.085a.47.47 0 0 0 .161-.925 6.922 6.922 0 0 0-1.037-.099c-1.84-.032-3.576.659-4.887 1.947s-2.034 3.011-2.034 4.85v.045A2.313 2.313 0 0 1 7.8 18.664a6.783 6.783 0 0 0-4.09 6.353c.03 1.758.736 3.418 1.988 4.675s2.91 1.968 4.668 2.004a6.724 6.724 0 0 0 4.272-1.398 2.243 2.243 0 0 1 2.725 0 6.72 6.72 0 0 0 4.128 1.4l.145-.001c1.758-.036 3.416-.748 4.668-2.004s1.958-2.917 1.988-4.675a6.781 6.781 0 0 0-4.09-6.353zM3.851 7.351C1.728 7.351 0 9.079 0 11.202s1.728 3.851 3.851 3.851 3.851-1.727 3.851-3.851-1.728-3.851-3.851-3.851zm0 6.763c-1.606 0-2.912-1.306-2.912-2.912S2.245 8.29 3.851 8.29c1.606 0 2.912 1.306 2.912 2.912s-1.306 2.912-2.912 2.912zM10.9.302c-2.123 0-3.851 1.728-3.851 3.851S8.776 8.004 10.9 8.004s3.851-1.728 3.851-3.851A3.856 3.856 0 0 0 10.9.302zm0 6.763c-1.606 0-2.912-1.306-2.912-2.912S9.294 1.241 10.9 1.241c1.606 0 2.912 1.306 2.912 2.912S12.506 7.065 10.9 7.065zm19.402.944a.47.47 0 0 0-.526.778 2.911 2.911 0 1 1-2.823-.241.47.47 0 1 0-.386-.856 3.86 3.86 0 0 0-2.27 3.512c0 2.123 1.727 3.851 3.851 3.851s3.851-1.728 3.851-3.851a3.85 3.85 0 0 0-1.698-3.193zM21.1.302c-2.123 0-3.851 1.728-3.851 3.851s1.727 3.851 3.851 3.851 3.851-1.728 3.851-3.851A3.855 3.855 0 0 0 21.1.302zm0 6.763c-1.606 0-2.912-1.306-2.912-2.912s1.306-2.912 2.912-2.912 2.912 1.306 2.912 2.912-1.306 2.912-2.912 2.912z"
  })));
};

/* harmony default export */ var dog = (SvgDog);
// EXTERNAL MODULE: ./src/lib/filters/number.js
var number = __webpack_require__(47276);
;// CONCATENATED MODULE: ./src/components/search/item.js




















function item_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function item_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            item_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchItem(param) {
    var item1 = param.item, openBasementModal = param.openBasementModal, filter = param.filter;
    var ref2, ref1;
    var router = (0,next_router.useRouter)();
    // eslint-disable-next-line no-mixed-operators
    var calculateDiscount = function() {
        return Math.floor(100 - item1.total_price / (item1.original_price + item1.surcharge) * 100);
    };
    var buildLink = function() {
        var ref;
        var linkObj = {
            pathname: "/yacht/".concat(item1.boat.slug),
            query: item_objectSpread({}, router.query, {
                bq: item1.booking_query
            })
        };
        if (((ref = linkObj.query) === null || ref === void 0 ? void 0 : ref.date_from) === undefined || linkObj.query.date_from === '') {
            linkObj.query.date_from = item1.date_from;
        }
        return linkObj;
    };
    var specs = [
        {
            icon: user/* default */.Z,
            label: 'Kojen',
            value: "".concat(item1.boat.berth.fixed).concat(item1.boat.berth.variable ? " (+ ".concat(item1.boat.berth.variable, ")") : '')
        },
        {
            icon: bed/* default */.Z,
            label: 'Kabinen',
            value: item1.boat.cabins
        },
        {
            icon: anker_length/* default */.Z,
            label: 'L\xe4nge',
            value: "".concat((0,number/* default */.Z)(item1.boat.length), " m")
        },
        {
            icon: construction,
            label: 'Baujahr',
            value: item1.boat.construction || '-'
        },
        {
            icon: lightning,
            label: 'PS',
            value: item1.boat.ps || '-',
            className: 'hidden sm:block'
        },
        {
            icon: mainsail,
            label: 'Hauptsegel',
            value: item1.boat.sail_type || '-',
            className: 'hidden sm:block'
        },
        {
            icon: genoa,
            label: 'Genoa',
            value: item1.boat.genoa_type || '-',
            className: 'hidden sm:block'
        },
        {
            icon: dog,
            label: 'Tiermitname',
            value: item1.boat.animals ? 'erlaubt' : 'auf Anfrage',
            className: 'col-span-2 sm:col-span-1'
        }, 
    ];
    var isLicenseNeeded = function(item) {
        var isWithoutLicense = (0,CharterLicenseNotice/* DetermineCharterLicense */.KK)(item.boat, item).isWithoutLicense;
        return isWithoutLicense;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
            href: buildLink(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "flex flex-col justify-center space-y-4 text-primary-500 hover:text-primary-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    className: "self-center w-full overflow-hidden bg-white rounded-lg shadow group mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-full overflow-hidden sm:grid sm:grid-cols-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex flex-col flex-no-wrap sm:flex-row sm:col-span-2",
                                children: [
                                    ((ref2 = item1.boat) === null || ref2 === void 0 ? void 0 : ref2.photo_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: (0,helper_image/* default */.Z)(item1.boat.photo_url),
                                        alt: item1.boat.title,
                                        title: item1.boat.title,
                                        height: 200,
                                        width: 380,
                                        objectFit: "cover"
                                    }),
                                    calculateDiscount() > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute left-0 top-0 bg-red-600 text-white px-2 py-2 font-bold text-lg md:text-xl",
                                        children: [
                                            "-",
                                            calculateDiscount(),
                                            "%"
                                        ]
                                    }),
                                    (0,adac/* isAdacCustomer */.V)() && parseInt(filter.adac, 10) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 right-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-end gap-1 w-[65px]",
                                            "data-for": "adac-tooltip",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    title: "ADAC Vorteil",
                                                    alt: "ADAC Vorteil",
                                                    src: "/images/adac.svg",
                                                    objectFit: "contain",
                                                    height: 65,
                                                    width: 65
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-adac-fg bg-adac-bg w-full p-1 text-center text-xs",
                                                    children: "VORTEIL"
                                                })
                                            ]
                                        })
                                    }),
                                    isLicenseNeeded(item1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute bottom-0 bg-green-600 text-white py-1 w-full text-center opacity-90",
                                        children: "Mieten ohne F\xfchrerschein"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:col-span-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                        className: "relative px-3 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                className: "relative text-base font-semibold pt-3 leading-6 text-primary-500 line-clamp-2 sm:text-lg border-b",
                                                children: [
                                                    item1.boat.title,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute right-0 top-1 z-[40]",
                                                        onClick: function() {
                                                            return window.open("/partner/".concat(item1.team.slug)).focus();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: (0,helper_image/* default */.Z)(item1.team.photo_url),
                                                            alt: item1.team.name,
                                                            height: 30,
                                                            width: 80,
                                                            objectFit: "contain"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "flex items-center font-semibold",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar/* default */.Z, {
                                                                className: "mr-2",
                                                                width: 14
                                                            }),
                                                            (0,date/* default */.Z)(item1.date_from),
                                                            ' ',
                                                            "-",
                                                            ' ',
                                                            (0,date/* default */.Z)(item1.date_to),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-xs ml-2 leading-4 font-semibold bg-gray-100 rounded-xl text-primary-500 text-center py-0.5 px-2.5",
                                                                children: [
                                                                    item1.duration,
                                                                    ' ',
                                                                    "N\xe4chte"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                        className: "flex items-center text-sm",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            openBasementModal(item1.basement_start.id);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(port/* default */.Z, {
                                                                className: "mr-2 ml-0.5",
                                                                width: 12
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "line-clamp-1",
                                                                children: (ref1 = item1.basement_start.location) === null || ref1 === void 0 ? void 0 : ref1.half
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        id: "specs",
                                        className: "flex-1 grid grid-cols-3 sm:grid-cols-4 gap-x-4 gap-y-3 sm:gap-y-1 bg-gray-100 mt-4 px-3 py-2",
                                        children: specs.map(function(v) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                className: v.className || '',
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-7",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v.icon, {
                                                                    height: 14,
                                                                    className: "mr-2"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm font-semibold",
                                                                children: v.label
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-7 text-sm",
                                                        children: v.value
                                                    })
                                                ]
                                            }, v.label);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "price",
                                        className: "flex flex-col pt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-end justify-end space-x-2 sm:flex-col sm:pt-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "hidden sm:block text-xs leading-4 font-semibold bg-gray-100 rounded-t mr-0 text-primary-500 text-center py-0.5 px-2.5 ",
                                                    children: [
                                                        "Preis f\xfcr",
                                                        ' ',
                                                        item1.duration,
                                                        ' ',
                                                        "N\xe4chte"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "px-5 py-2 bg-gray-200 text-base font-bold leading-6 rounded-tl",
                                                            children: "Yachtdetails →"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: "px-5 py-2 bg-primary rounded-tr text-right text-white",
                                                            "data-cy": "boat-page-button",
                                                            children: [
                                                                item1.original_price + item1.surcharge !== item1.total_price && /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                                                    className: "block text-xs md:text-md text-red-600",
                                                                    children: (0,price/* default */.Z)(item1.original_price + item1.surcharge)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-bold leading-6 text-2xl",
                                                                    children: parseInt(filter.adac, 10) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            (0,price/* default */.Z)(item1.total_price * 0.975),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "font-bold leading-5 text-md mt-1 text-adac-fg",
                                                                                children: "ADAC-Vorteilspreis"
                                                                            })
                                                                        ]
                                                                    }) : (0,price/* default */.Z)(item1.total_price)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./src/components/search/got-questions.js



function GotQuestions() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden lg:flex flex-col items-center text-gray-700 p-4 text-center rounded shadow-sm border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-lg font-bold text-gray-700",
                children: "Fragen?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2",
                children: "Wir sind hier, um Ihnen bei der Planung des perfekten Hausbooturlaubs zu helfen."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                className: "flex flex-col items-center w-full pt-4 space-y-5 not-italic",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "space-x-2 text-base",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Telefon:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:".concat(app_config/* default.phone */.Z.phone),
                                className: "text-primary-500 hover:text-action-500",
                                children: app_config/* default.phone */.Z.phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                        href: "/kontakt",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "w-full py-2 text-base font-bold text-zz-blue-500 bg-white border-2 border-zz-blue-500 rounded-md hover:border-zz-turquoise-500 hover:text-zz-turquoise-500",
                            children: "Kontaktieren Sie uns"
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(70300);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components/elements/button.js
var elements_button = __webpack_require__(81474);
// EXTERNAL MODULE: ./src/components/elements/date-picker.js
var date_picker = __webpack_require__(11429);
// EXTERNAL MODULE: ./src/components/search/form/boat-type-select.js + 1 modules
var boat_type_select = __webpack_require__(90647);
// EXTERNAL MODULE: ./src/components/elements/select.js
var elements_select = __webpack_require__(5205);
;// CONCATENATED MODULE: ./src/components/search/form/cabin.js


function SearchFormCabin(param1) {
    var cabinMin = param1.cabinMin, cabinMax = param1.cabinMax, onCabinChange = param1.onCabinChange, _lowerBound = param1.lowerBound, lowerBound = _lowerBound === void 0 ? 1 : _lowerBound, _upperBound = param1.upperBound, upperBound = _upperBound === void 0 ? 7 : _upperBound;
    var generateOptionsBetween = function(min, max) {
        var options = [
            {
                value: undefined,
                label: ''
            }
        ];
        for(var i = min; i <= max; i += 1){
            options.push({
                value: i,
                label: i
            });
        }
        return options;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "kojen flex gap-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_select/* default */.Z, {
                mainClass: "flex-1",
                label: "Kabinen von",
                primary: true,
                selected: Number(cabinMin),
                options: generateOptionsBetween(lowerBound, Number(cabinMax || upperBound)),
                register: {
                    onChange: function(param) {
                        var target = param.target;
                        return onCabinChange(Number(target.value), cabinMax);
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_select/* default */.Z, {
                mainClass: "flex-1",
                label: "Kabinen bis",
                primary: true,
                selected: Number(cabinMax),
                options: generateOptionsBetween(Number(cabinMin || lowerBound), upperBound),
                register: {
                    onChange: function(param) {
                        var target = param.target;
                        return onCabinChange(cabinMin, Number(target.value));
                    }
                }
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/search/form/region.js
var form_region = __webpack_require__(78696);
// EXTERNAL MODULE: ./src/components/search/form/duration.js
var duration = __webpack_require__(4541);
// EXTERNAL MODULE: ./src/components/elements/checkbox.js
var elements_checkbox = __webpack_require__(99790);
// EXTERNAL MODULE: ./src/utils/defaultDate.js
var defaultDate = __webpack_require__(28091);
;// CONCATENATED MODULE: ./src/utils/minMaxApiParam.js
function createMinMaxParam(min, max) {
    if (min > 0 && max > 0) {
        return "btw:".concat(min, ",").concat(max);
    }
    if (min > 0) {
        return "gte:".concat(min);
    }
    if (max > 0) {
        return "lte:".concat(max);
    }
    return undefined;
}
function extractMinMaxParam(apiParam, regex) {
    var match = apiParam === null || apiParam === void 0 ? void 0 : apiParam.match(regex);
    if ((match === null || match === void 0 ? void 0 : match.length) === 2) {
        return Number(match[1]);
    }
    return undefined;
}
// noinspection RegExpUnnecessaryNonCapturingGroup
var MIN_VALUE = /(?:(?:gte:)|(?:btw:))(\d+)/;
// noinspection RegExpUnnecessaryNonCapturingGroup
var MAX_VALUE = /(?:(?:lte:)|(?:btw:\d+,))(\d+)/;

;// CONCATENATED MODULE: ./src/components/search/top-form.js
















function top_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchTopForm(param) {
    var filter = param.filter, onChangeAdvancedFilter = param.onChangeAdvancedFilter, _basements = param.basements, basements = _basements === void 0 ? null : _basements;
    var ref10;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)('boat').t;
    var buildMockLocationsObj = function(id) {
        if (id !== '' && id !== undefined) {
            return {
                id: id
            };
        }
        return null;
    };
    var ref1 = (0,react.useState)(buildMockLocationsObj(filter === null || filter === void 0 ? void 0 : filter.country)), country = ref1[0], setCountry = ref1[1];
    var ref2 = (0,react.useState)(buildMockLocationsObj(filter === null || filter === void 0 ? void 0 : filter.region_id)), region = ref2[0], setRegion = ref2[1];
    var ref3 = (0,react.useState)(filter.location_id || ''), locationId = ref3[0], setLocationId = ref3[1];
    var ref4 = (0,react.useState)(filter.sd || ''), sd = ref4[0], setSd = ref4[1];
    var ref5 = (0,react.useState)(null), triggerRebuildRegion = ref5[0], setTriggerRebuildRegion = ref5[1];
    var ref6 = (0,index_esm/* useForm */.cI)({
        // notice: default values may be overridden by useEffect watching for [filter]
        defaultValues: {
            sd: filter.sd || '',
            country: filter.country || '',
            region_id: filter.region_id || '',
            location_id: filter.location_id || '',
            date_from: (filter === null || filter === void 0 ? void 0 : (ref10 = filter.date_from) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 ? filter.date_from : (0,defaultDate/* default */.Z)(),
            date_to: filter.date_to || '',
            duration: filter.duration || '7',
            adac: "".concat(filter.adac) === '1' ? 1 : 0,
            boat_type_id: filter.boat_type_id
        }
    }), errors = ref6.formState.errors, clearErrors = ref6.clearErrors, register = ref6.register, handleSubmit = ref6.handleSubmit, getValues = ref6.getValues, setValue = ref6.setValue;
    register('country', {
        required: 'Bitte w\xe4hlen Sie ein Fahrgebiet aus.'
    });
    var ref7 = (0,react.useState)(NaN), cabinMin = ref7[0], setCabinMin = ref7[1];
    var ref8 = (0,react.useState)(NaN), cabinMax = ref8[0], setCabinMax = ref8[1];
    (0,react.useEffect)(function() {
        Object.keys(filter).forEach(function(key) {
            var value = filter[key];
            setValue(key, value);
        });
        if ((filter === null || filter === void 0 ? void 0 : filter.sd) !== sd || (filter === null || filter === void 0 ? void 0 : filter.country) !== (country === null || country === void 0 ? void 0 : country.id) || (filter === null || filter === void 0 ? void 0 : filter.region) !== (region === null || region === void 0 ? void 0 : region.id)) {
            setSd(filter.sd || '');
            setCountry(buildMockLocationsObj(filter === null || filter === void 0 ? void 0 : filter.country));
            setRegion(buildMockLocationsObj(filter === null || filter === void 0 ? void 0 : filter.region_id));
            setLocationId(filter.location_id || '');
            setTriggerRebuildRegion(Date.now());
        }
        setCabinMin(extractMinMaxParam(filter.cabins, MIN_VALUE));
        setCabinMax(extractMinMaxParam(filter.cabins, MAX_VALUE));
    }, [
        filter
    ]);
    // reset state on unmount
    (0,react.useEffect)(function() {
        return function() {
            setCountry(null);
            setRegion(null);
            setLocationId('');
            setSd('');
        };
    }, []);
    var onSubmit = function() {
        var ref, ref9;
        ;
        var formValues = getValues();
        ;
        if (formValues.animals === 0) {
            formValues.animals = '';
        }
        if (formValues.date_from === '' || !moment_default()(formValues.date_from).isValid()) {
        // formValues.date_from = moment().format('YYYY-MM-DD');
        }
        if (formValues.date_from !== '' || moment_default()(formValues.date_from).isValid()) {
            formValues.date_to = moment_default()(formValues.date_from).add(3, 'weeks').format('YYYY-MM-DD');
        }
        var cabinParam = createMinMaxParam(cabinMin, cabinMax);
        if (cabinParam) {
            formValues.cabins = cabinParam;
        }
        var query = top_form_objectSpread({}, router.query, formValues, {
            page: 1
        });
        var uniformFields = function(field) {
            if (field === null || field === undefined || field === '') return null;
            return "".concat(field);
        };
        if (((ref = router.query) === null || ref === void 0 ? void 0 : (ref9 = ref.slug) === null || ref9 === void 0 ? void 0 : ref9.length) > 1 && basements === null && (uniformFields(formValues === null || formValues === void 0 ? void 0 : formValues.country) !== uniformFields(filter === null || filter === void 0 ? void 0 : filter.country) || uniformFields(formValues === null || formValues === void 0 ? void 0 : formValues.region_id) !== uniformFields(filter === null || filter === void 0 ? void 0 : filter.region_id) || uniformFields(formValues === null || formValues === void 0 ? void 0 : formValues.location_id) !== uniformFields(filter === null || filter === void 0 ? void 0 : filter.location_id))) {
            router.push({
                pathname: app_config/* default.primarySearchPage */.Z.primarySearchPage,
                hash: 'search-content',
                query: query
            });
        } else {
            router.push({
                hash: 'search-content',
                query: query
            });
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-20 bg-action-500 mb-7 lg:mb-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container max-w-screen-xl mx-auto p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-2xl font-semibold mt-0 mb-3 text-primary",
                        children: "Suche"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        className: "grid gap-y-4 sm:grid-cols-4 grid-cols-1 lg:grid-cols-1 gap-x-2",
                        "data-cy": "search-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_region/* default */.Z, {
                                    className: "relative pl-10 pr-5 h-12 w-full block rounded truncate z-20",
                                    setValue: function(v) {
                                        setValue('sd', v);
                                        setSd(v);
                                    },
                                    sd: sd,
                                    errors: errors,
                                    country: country,
                                    region: region,
                                    locationId: locationId,
                                    interacted: function() {
                                        return clearErrors('country');
                                    },
                                    setCountry: function(v) {
                                        setValue('country', (v === null || v === void 0 ? void 0 : v.country_id) || '');
                                        setCountry(v);
                                    },
                                    setRegion: function(v) {
                                        setValue('region_id', (v === null || v === void 0 ? void 0 : v.region_id) || '');
                                        setRegion(v);
                                    },
                                    setLocationId: function(v) {
                                        setValue('location_id', v || '');
                                        setLocationId(v);
                                    },
                                    next: function() {},
                                    reInitialize: triggerRebuildRegion,
                                    basements: basements
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker/* default */.Z, {
                                    inputDate: getValues('date_from'),
                                    setValue: function(field, value) {
                                        setValue('date_from', value);
                                    },
                                    onDateChange: function() {}
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(duration/* default */.Z, {
                                    form: getValues(),
                                    value: getValues('duration'),
                                    setValue: function(field, value) {
                                        return setValue(field, value);
                                    },
                                    next: function() {}
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(boat_type_select/* default */.Z, {
                                    value: getValues('boat_type_id'),
                                    setValue: function(field, value) {
                                        return setValue(field, value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormCabin, {
                                    cabinMin: cabinMin,
                                    cabinMax: cabinMax,
                                    onCabinChange: function(min, max) {
                                        setCabinMin(min);
                                        setCabinMax(max);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_checkbox/* default */.Z, {
                                    value: getValues('adac'),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Ich bin",
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "ADAC Mitglied"
                                            })
                                        ]
                                    }),
                                    name: "adac",
                                    setValue: function(v) {
                                        setValue('adac', v);
                                        onSubmit();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm-col-span-1 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return onChangeAdvancedFilter();
                                    },
                                    className: "cursor-pointer border border-transparent text-center appearance-none select-none bg-gray-500 text-white hover:text-white hover:bg-gray-600 active:bg-gray-600 text-base px-6 w-full h-11 leading-11",
                                    children: "Weitere Filter"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                                    type: "submit",
                                    width: "w-full",
                                    variant: "primary",
                                    dataCy: "submit-search",
                                    children: t('Search')
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/elements/pagination.js
var pagination = __webpack_require__(88304);
// EXTERNAL MODULE: ./src/components/elements/input.js
var input = __webpack_require__(66505);
// EXTERNAL MODULE: ./node_modules/rc-slider/es/index.js + 66 modules
var es = __webpack_require__(70400);
// EXTERNAL MODULE: ./node_modules/rc-slider/assets/index.css
var assets = __webpack_require__(87042);
;// CONCATENATED MODULE: ./src/components/elements/range-slider.js



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var createSliderWithTooltip = es/* default.createSliderWithTooltip */.ZP.createSliderWithTooltip;
var Range = createSliderWithTooltip(es/* default.Range */.ZP.Range);
function RangeSlider3(param1) {
    var initialMin = param1.initialMin, initialMax = param1.initialMax, min1 = param1.min, max1 = param1.max, step = param1.step, onChangeHandler = param1.onChangeHandler, name = param1.name, _marks = param1.marks, marks = _marks === void 0 ? false : _marks;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col mt-4 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                    min: min1,
                    max: max1,
                    step: step,
                    defaultValue: [
                        initialMin,
                        initialMax
                    ],
                    allowCross: false,
                    onAfterChange: function(param) {
                        var _param = _slicedToArray(param, 2), min = _param[0], max = _param[1];
                        onChangeHandler(name, min, max);
                    },
                    trackStyle: [
                        {
                            backgroundColor: 'rgb(22, 163, 74)'
                        }
                    ],
                    handleStyle: [
                        {
                            border: '1px solid gray',
                            width: '1.125rem',
                            height: '1.125rem'
                        }
                    ],
                    dotStyle: {
                        border: '1px solid gray'
                    },
                    marks: marks
                })
            }),
            marks === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-sm mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: min1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-auto",
                        children: max1
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/radio-group/radio-group.js + 4 modules
var radio_group = __webpack_require__(98758);
;// CONCATENATED MODULE: ./src/components/inputs/thruster.js





var settings = [
    {
        name: 'beliebig',
        query: ''
    },
    {
        name: 'Mit Bugstrahlruder',
        query: 'in:0,2'
    }, 
];
var queryName = 'thruster';
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(' ');
}
function InputThruster() {
    var router = (0,next_router.useRouter)();
    var preSelectFilterValueFromUrlQuery = function() {
        var query = router.query;
        var index = 0;
        if (query[queryName]) {
            index = settings.findIndex(function(elem) {
                return elem.value === query[queryName];
            });
        }
        return index;
    };
    var ref = (0,react.useState)(settings[preSelectFilterValueFromUrlQuery()]), selected = ref[0], setSelected = ref[1];
    var onChangeSelection = function(item) {
        setSelected(item);
        var query = router.query;
        query[queryName] = item.query;
        query.page = '1';
        router.push({
            pathname: app_config/* default.primarySearchPage */.Z.primarySearchPage,
            query: query
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_group/* RadioGroup */.E, {
        value: selected,
        onChange: onChangeSelection,
        className: "-mx-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                className: "sr-only",
                children: "Strahlruder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " rounded-md -space-y-px",
                children: settings.map(function(setting, settingIdx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Option */.E.Option, {
                        value: setting,
                        className: function(param) {
                            var checked = param.checked;
                            return classNames(settingIdx === 0 ? '' : '', settingIdx === settings.length - 1 ? '' : '', checked ? 'bg-action-100 border-primary-200 z-10' : 'border-gray-200', 'relative px-4 py-2.5 flex cursor-pointer focus:outline-none');
                        },
                        children: function(param) {
                            var active = param.active, checked = param.checked;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classNames(checked ? 'bg-primary-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-primary-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer shrink-0 rounded-full border flex items-center justify-center'),
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "rounded-full bg-white w-1.5 h-1.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-3 flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                                            as: "span",
                                            className: classNames(checked ? 'text-primary-900' : 'text-gray-900', 'block text-sm font-medium'),
                                            children: setting.name
                                        })
                                    })
                                ]
                            });
                        }
                    }, setting.name);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/inputs/sail.js





var sail_settings = [
    {
        name: 'beliebig',
        query: ''
    },
    {
        name: 'Lattengro\xdfsegel',
        query: 'in:1,2,4,7'
    },
    {
        name: 'Rollgro\xdf',
        query: 'in:3,8'
    }, 
];
var sail_queryName = 'sail_type_id';
function sail_classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(' ');
}
function InputSail() {
    var router = (0,next_router.useRouter)();
    var preSelectFilterValueFromUrlQuery = function() {
        var query = router.query;
        var index = 0;
        if (query[sail_queryName]) {
            index = sail_settings.findIndex(function(elem) {
                return elem.value === query[sail_queryName];
            });
        }
        return index;
    };
    var ref = (0,react.useState)(sail_settings[preSelectFilterValueFromUrlQuery()]), selected = ref[0], setSelected = ref[1];
    var onChangeSelection = function(item) {
        setSelected(item);
        var query = router.query;
        query[sail_queryName] = item.query;
        query.page = '1';
        router.push({
            pathname: app_config/* default.primarySearchPage */.Z.primarySearchPage,
            query: query
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_group/* RadioGroup */.E, {
        value: selected,
        onChange: onChangeSelection,
        className: "-mx-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                className: "sr-only",
                children: "Strahlruder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " rounded-md -space-y-px",
                children: sail_settings.map(function(setting, settingIdx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Option */.E.Option, {
                        value: setting,
                        className: function(param) {
                            var checked = param.checked;
                            return sail_classNames(settingIdx === 0 ? '' : '', settingIdx === sail_settings.length - 1 ? '' : '', checked ? 'bg-action-100 border-primary-200 z-10' : 'border-gray-200', 'relative px-4 py-2.5 flex cursor-pointer focus:outline-none');
                        },
                        children: function(param) {
                            var active = param.active, checked = param.checked;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: sail_classNames(checked ? 'bg-primary-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-primary-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer shrink-0 rounded-full border flex items-center justify-center'),
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "rounded-full bg-white w-1.5 h-1.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-3 flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                                            as: "span",
                                            className: sail_classNames(checked ? 'text-primary-900' : 'text-gray-900', 'block text-sm font-medium'),
                                            children: setting.name
                                        })
                                    })
                                ]
                            });
                        }
                    }, setting.name);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/inputs/construction-year.js






var construction_year_settings = [
    {
        name: 'beliebig',
        query: ''
    },
    {
        name: 'weniger als 3 Jahre',
        query: "gt:".concat(dayjs_min_default()().subtract(3, 'year').format('YYYY'))
    },
    {
        name: 'weniger als 5 Jahre',
        query: "gt:".concat(dayjs_min_default()().subtract(5, 'year').format('YYYY'))
    },
    {
        name: 'weniger als 10 Jahre',
        query: "gt:".concat(dayjs_min_default()().subtract(10, 'year').format('YYYY'))
    },
    {
        name: 'mehr als 10 Jahre',
        query: "lt:".concat(dayjs_min_default()().subtract(10, 'year').format('YYYY'))
    }, 
];
var construction_year_queryName = 'construction';
function construction_year_classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(' ');
}
function InputConstructionYear() {
    var router = (0,next_router.useRouter)();
    var preSelectFilterValueFromUrlQuery = function() {
        var query = router.query;
        var index = 0;
        if (query[construction_year_queryName]) {
            index = construction_year_settings.findIndex(function(elem) {
                return elem.value === query[construction_year_queryName];
            });
        }
        return index;
    };
    var ref = (0,react.useState)(construction_year_settings[preSelectFilterValueFromUrlQuery()]), selected = ref[0], setSelected = ref[1];
    var onChangeSelection = function(item) {
        setSelected(item);
        var query = router.query;
        query[construction_year_queryName] = item.query;
        query.page = '1';
        router.push({
            pathname: app_config/* default.primarySearchPage */.Z.primarySearchPage,
            query: query
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_group/* RadioGroup */.E, {
        value: selected,
        onChange: onChangeSelection,
        className: "-mx-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                className: "sr-only",
                children: "Strahlruder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " rounded-md -space-y-px",
                children: construction_year_settings.map(function(setting, settingIdx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Option */.E.Option, {
                        value: setting,
                        className: function(param) {
                            var checked = param.checked;
                            return construction_year_classNames(settingIdx === 0 ? '' : '', settingIdx === construction_year_settings.length - 1 ? '' : '', checked ? 'bg-action-100 border-primary-200 z-10' : 'border-gray-200', 'relative px-4 py-2.5 flex cursor-pointer focus:outline-none');
                        },
                        children: function(param) {
                            var active = param.active, checked = param.checked;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: construction_year_classNames(checked ? 'bg-primary-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-primary-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer shrink-0 rounded-full border flex items-center justify-center'),
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "rounded-full bg-white w-1.5 h-1.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-3 flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                                            as: "span",
                                            className: construction_year_classNames(checked ? 'text-primary-900' : 'text-gray-900', 'block text-sm font-medium'),
                                            children: setting.name
                                        })
                                    })
                                ]
                            });
                        }
                    }, setting.name);
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./public/assets/icons/cross-out.svg
var cross_out = __webpack_require__(73837);
;// CONCATENATED MODULE: ./src/components/search/filter.js














function filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchFilter(param1) {
    var filter1 = param1.filter, onFilterChange = param1.onFilterChange, showFilter = param1.showFilter, onChangeShowFilter = param1.onChangeShowFilter;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)('boat').t;
    (0,react.useEffect)(function() {
        if (showFilter) {
            document.querySelector('body').classList.add('overflow-hidden');
        } else {
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    }, [
        showFilter
    ]);
    var ref4 = (0,react.useState)(null), minPrice = ref4[0], setMinPrice = ref4[1];
    var ref1 = (0,react.useState)(null), maxPrice = ref1[0], setMaxPrice = ref1[1];
    (0,react.useEffect)(function() {
        setMinPrice(extractMinMaxParam(filter1.price, MIN_VALUE));
        setMaxPrice(extractMinMaxParam(filter1.price, MAX_VALUE));
    }, [
        filter1
    ]);
    var _q;
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            search: (_q = router.query.q) !== null && _q !== void 0 ? _q : ''
        }
    }), handleSubmit = ref2.handleSubmit, getValues = ref2.getValues, setValue = ref2.setValue, register = ref2.register;
    var onSubmit = function(data) {
        var filter = {
            q: data.search,
            price: createMinMaxParam(minPrice, maxPrice)
        };
        onFilterChange(filter);
        if (showFilter) {
            onChangeShowFilter();
        }
    };
    var onSliderChange = function(name, min, max) {
        onFilterChange(name, "btw:".concat(min, ",").concat(max));
    };
    var getFilterMinValueFromRange = function(filterName, defaultValue) {
        var ref;
        var match = (ref = filter1[filterName]) === null || ref === void 0 ? void 0 : ref.match(/:(\d*),/);
        if ((match === null || match === void 0 ? void 0 : match.length) === 2) {
            return Number(match[1]);
        }
        return defaultValue;
    };
    var ref3 = (0,react.useState)(filter1.sort), sorting = ref3[0], setSorting = ref3[1];
    var onChangeSorting = function(sort) {
        setSorting(sort);
        onFilterChange('sort', sort);
    };
    var onChangeMinPrice = function(price) {
        setMinPrice(price);
    };
    var onChangeMaxPrice = function(price) {
        setMaxPrice(price);
    };
    var getFilterMaxValueFromRange = function(filterName, defaultValue) {
        var ref;
        var match = (ref = filter1[filterName]) === null || ref === void 0 ? void 0 : ref.match(/:\d*,(\d*)/);
        if ((match === null || match === void 0 ? void 0 : match.length) === 2) {
            return Number(match[1]);
        }
        return defaultValue;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100 lg:mb-0 lg:block ".concat(showFilter ? 'fixed left-0 top-0 w-full h-screen p-4 z-[10001] overflow-auto' : 'hidden'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container max-w-screen-xl mx-auto p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: "grid gap-y-4 grid-cols-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-2xl font-semibold mt-0",
                            children: [
                                "Filter",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lg:hidden w-6 h-6 float-right z-60",
                                    onClick: onChangeShowFilter,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cross_out/* default */.Z, {
                                        className: "w-6 h-6 cursor-pointer",
                                        alt: "Filtereinstellungen schlie\xdfen"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
                                    className: "border-b pb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                            register: filter_objectSpread({}, register('search')),
                                            value: getValues('search'),
                                            setValue: function(v) {
                                                setValue('search', v);
                                            },
                                            name: "search",
                                            label: "Suchbegriff",
                                            placeholder: "Modell, Anbieter, Bootsname oder Nr."
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
                                    className: "pb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                type: "number",
                                                label: "Preis ab",
                                                register: {
                                                    onChange: function(param) {
                                                        var target = param.target;
                                                        return onChangeMinPrice(target.value);
                                                    },
                                                    value: minPrice
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                type: "number",
                                                label: "Preis bis",
                                                register: {
                                                    onChange: function(param) {
                                                        var target = param.target;
                                                        return onChangeMaxPrice(target.value);
                                                    },
                                                    value: maxPrice
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                                    type: "submit",
                                    width: "w-full",
                                    size: "sm",
                                    variant: "action",
                                    "data-cy": "search-query-submit",
                                    children: t('Search')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Sortieren nach"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_select/* default */.Z, {
                                            id: "sorting",
                                            name: "sorting",
                                            register: {
                                                onChange: function(param) {
                                                    var target = param.target;
                                                    return onChangeSorting(target.value);
                                                }
                                            },
                                            selected: sorting,
                                            options: [
                                                {
                                                    value: 'date_from',
                                                    label: 'Datum'
                                                },
                                                {
                                                    value: 'total_price',
                                                    label: 'Preis'
                                                },
                                                {
                                                    value: 'date_from,total_price',
                                                    label: 'Datum und Preis'
                                                }, 
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "pb-2 border-b",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Badezimmer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider3, {
                                            name: "baths",
                                            initialMin: getFilterMinValueFromRange('baths', 1),
                                            initialMax: getFilterMaxValueFromRange('baths', 6),
                                            min: 1,
                                            max: 6,
                                            step: 1,
                                            onChangeHandler: onSliderChange
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Baujahr"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider3, {
                                            name: "construction",
                                            initialMin: getFilterMinValueFromRange('construction', 1980),
                                            initialMax: getFilterMaxValueFromRange('construction', 2022),
                                            min: 1980,
                                            max: 2022,
                                            step: 3,
                                            priceCap: 1000,
                                            onChangeHandler: onSliderChange
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "border-b pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Baujahr"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputConstructionYear, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "border-b pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Strahlruder"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputThruster, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "border-b pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "Hauptsegel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSail, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                        className: "font-semibold mb-1 text-sm",
                                        children: "L\xe4nge"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider3, {
                                            name: "length",
                                            initialMin: getFilterMinValueFromRange('length', 0),
                                            initialMax: getFilterMaxValueFromRange('length', 50),
                                            min: 0,
                                            max: 50,
                                            step: 2,
                                            onChangeHandler: onSliderChange,
                                            marks: {
                                                0: '0m',
                                                10: '10m',
                                                20: '20m',
                                                30: '30m',
                                                40: '40m',
                                                50: '50m'
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/search/index.js
















function search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_slicedToArray(arr, i) {
    return search_arrayWithHoles(arr) || search_iterableToArrayLimit(arr, i) || search_unsupportedIterableToArray(arr, i) || search_nonIterableRest();
}
function search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen);
}
function Search(param1) {
    var data = param1.data, meta = param1.meta, filter = param1.filter, _content = param1.content, content1 = _content === void 0 ? '' : _content, setData = param1.setData, setMeta = param1.setMeta, _basements = param1.basements, basements = _basements === void 0 ? null : _basements;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(filter), stateFilter = ref[0], setStateFilter = ref[1];
    var ref1 = (0,react.useState)(false), showAdvancedFilter = ref1[0], setShowAdvancedFilter = ref1[1];
    var ref2 = (0,react.useState)(null), popupBasementId = ref2[0], setPopupBasementId = ref2[1];
    var ref3 = (0,react.useState)(false), isModalOpen = ref3[0], setIsModalOpen = ref3[1];
    (0,react.useEffect)(function() {
        setStateFilter(filter);
    }, [
        filter
    ]);
    (0,react.useEffect)(function() {
        var id = router.asPath.match(/#([a-z0-9]+)/gi);
        var content = document.getElementById('filter-animals'); // offset for search
        if (id && id[0] === '#search' && content && window.innerWidth < 870) {
            content.scrollIntoView();
        }
    }, []);
    var openBasementModal = function(basementId) {
        setPopupBasementId(basementId);
        setTimeout(function() {
            setIsModalOpen(true);
        }, 20);
    };
    var onCloseModal = function() {
        setIsModalOpen(false);
        setTimeout(function() {
            setPopupBasementId(null);
        }, 200);
    };
    var isFirstResultLaterThanInputDate = function() {
        if (data.length > 0 && stateFilter.date_from !== '' && stateFilter.page < 2 && stateFilter.sort !== 'total_price') {
            var inputDate = dayjs_min_default()(stateFilter.date_from);
            return inputDate.diff(data[0].date_from, 'day') !== 0;
        }
        return false;
    };
    var fetchResultsForFilter = function(filters) {
        var url = new URL(window.location);
        Object.entries(filters).forEach(function(param) {
            var _param = search_slicedToArray(param, 2), filterName = _param[0], filterValue = _param[1];
            url.searchParams.set(filterName, filterValue);
            if (filterName !== 'page') {
                url.searchParams.set('page', '1');
            } else {
                url.searchParams.set('page', filterValue);
            }
            if (url.searchParams.get('group') === null) {
                url.searchParams.set('group', 'model');
            }
            if (filterValue === undefined) {
                url.searchParams.delete(filterName);
            }
        });
        router.push(url, undefined, {
            shallow: true
        });
        nprogress_default().start();
        var searchFilter = Object.assign(stateFilter, Object.fromEntries(url.searchParams.entries()));
        delete searchFilter.slug;
        setStateFilter(search_objectSpread({}, stateFilter, filters));
        (0,connect/* fetchAPI */.Io)('/search', searchFilter).then(function(result) {
            setData(result === null || result === void 0 ? void 0 : result.data);
            setMeta(result.meta);
        }).finally(function() {
            var content = document.getElementById('search-content');
            if (content) {
                content.scrollIntoView();
            }
            nprogress_default().done();
        });
    };
    var fetchResults = function(filterName, filterValue) {
        fetchResultsForFilter(search_defineProperty({}, filterName, filterValue));
    };
    var ReactTooltip = (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 735).then(__webpack_require__.bind(__webpack_require__, 38735));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(38735)
                ];
            }
        },
        ssr: false
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0 mt-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row lg:space-x-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: "flex flex-col lg:w-1/4 lg:space-y-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTopForm, {
                                filter: stateFilter,
                                onChangeAdvancedFilter: function() {
                                    setShowAdvancedFilter(!showAdvancedFilter);
                                },
                                basements: basements
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter, {
                                filter: stateFilter,
                                onFilterChange: function(filters) {
                                    fetchResultsForFilter(filters);
                                },
                                showFilter: showAdvancedFilter,
                                onChangeShowFilter: function() {
                                    setShowAdvancedFilter(!showAdvancedFilter);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GotQuestions, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "flex flex-col flex-1 pb-10 space-y-4 pt-[100px] mt-[-100px]",
                        id: "search-content",
                        children: [
                            content1,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(content1 ? '' : 'md:mt-20'),
                                children: [
                                    isFirstResultLaterThanInputDate() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "alert alert-success text-sm",
                                        "data-cy": "search-notice-date",
                                        children: [
                                            "Leider stehen f\xfcr den",
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: (stateFilter === null || stateFilter === void 0 ? void 0 : stateFilter.date_from) === undefined || stateFilter.date_from === '' ? (0,date/* default */.Z)(dayjs_min_default()()) : (0,date/* default */.Z)(stateFilter.date_from)
                                            }),
                                            ' ',
                                            "keine Termine mehr zur Verf\xfcgung. Folgende alternative Termine stehen zur Auswahl:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactTooltip, {
                                        id: "adac-tooltip",
                                        effect: "solid",
                                        children: [
                                            "Lieber ADAC Kunde,",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "bei Buchung dieses Bootes erhalten Sie - nach Eingabe Ihrer ADAC Kundennummer einen Sonderrabatt."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col space-y-3 lg:space-y-4",
                                        "data-cy": "search-results",
                                        children: data.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem, {
                                                    item: item,
                                                    filter: stateFilter,
                                                    openBasementModal: openBasementModal
                                                })
                                            }, item.booking_query);
                                        })
                                    }),
                                    meta.total > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCatalogSchema, {
                                                items: data
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                                perPage: meta.per_page,
                                                current: meta.current_page,
                                                total: meta.total,
                                                paginate: function(p) {
                                                    fetchResults('page', p);
                                                }
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-primary text-white p-3 text-center font-bold",
                                        children: "Leider konnten keine Ergebnisse gefunden werden. Bitte \xe4ndern Sie das Datum oder die Filtereinstellungen."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            popupBasementId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Basement, {
                open: isModalOpen,
                setOpen: onCloseModal,
                basementId: popupBasementId
            })
        ]
    }));
};


/***/ }),

/***/ 90313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ isAdacCustomer; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

// eslint-disable-next-line import/prefer-default-export
function isAdacCustomer() {
    return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get('ref') === 'adac';
}


/***/ }),

/***/ 62279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

// eslint-disable-next-line import/no-anonymous-default-export
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(val, format) {
    var f = format || 'DD.MM.YYYY';
    if (!val || val.length === 0) {
        return '';
    }
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(val, 'YYYY-MM-DD').format(f);
};


/***/ }),

/***/ 28091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ defaultDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function defaultDate() {
    var today = moment__WEBPACK_IMPORTED_MODULE_0___default()();
    var date;
    // month is zero indexed -> month: 3 represents april
    if (today.month() < 2) {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()({
            month: 3,
            day: 1
        });
    } else if (today.month() < 10) {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, 'month');
    } else {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()({
            year: today.year() + 1,
            month: 3,
            day: 1
        });
    }
    return date.format('YYYY-MM-DD');
};


/***/ })

}]);